import 'views/registration/shop.less'

import {Icon} from '@codeurs/front'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import React from 'react'
import {formatPrice} from 'util/currency'
import {useTranslation} from 'util/i18n'
import {style} from 'util/style'
import {Theme} from 'views/theme'

const styles = style('shop', ['content', 'basket', 'basketitem'])

export const Shop: React.FC = ({children}) => {
	return (
		<div {...styles}>
			<div {...styles('frame')}>
				<Theme.Container {...styles('inner')}>{children}</Theme.Container>
			</div>
		</div>
	)
}

export const ShopContent: React.FC = ({children}) => {
	return (
		<div className="shop-content">
			<div className="shop-content-container">{children}</div>
		</div>
	)
}

export const ShopBasket: React.FC<{registration: RegistrationModel}> = data => {
	const {registration} = data
	const t = useTranslation()

	return (
		<div className={styles.basket}>
			<div className={styles.basket('contents')}>
				<a
					class={styles.basket('contact')}
					target="_blank"
					href={
						!registration.isOnsite && registration.contactLink
							? registration.contactLink?.url
							: undefined
					}
				>
					{registration.general.need_help ||
						registration.contactLink?.description ||
						registration.contactLink.title}
					{!registration.isOnsite && (
						<Icon {...styles.basket('contact-icon')} icon="arrow-long"></Icon>
					)}
				</a>
				{registration.event.packs.length > 1 &&
					registration.packs.length === 0 && (
						<div {...styles.basket('title')}>
							{t('shopbasket.title.nolength')}
						</div>
					)}
				{registration.packs.length > 0 && (
					<div {...styles.basket('title')}>{t('shopbasket.title.length')}</div>
				)}
				{registration.packs.map(pack => (
					<>
						<ShopBasketItem
							title={pack.label}
							description={pack.description}
							price={pack.getPriceFor(registration)}
						/>
						{pack.getUniqueSelectedOptions(registration).map(option => (
							<ShopBasketItem
								title={option.label}
								indent={true}
								description={option.getChoiceFor(registration).label}
								price={option
									.getChoiceFor(registration)
									.getPriceFor(registration)}
							/>
						))}
						{registration.tours
							.filter(tour => pack.tracksSet.has(tour.track))
							.map(tour => (
								<ShopBasketItem
									title={
										pack.tracks.length > 1
											? tour.track.label + ' - ' + tour.title
											: tour.title
									}
									description={tour.time}
									indent={true}
								/>
							))}
					</>
				))}
				{registration.sharedSelectedOptions.map(option => (
					<ShopBasketItem
						title={option.label}
						description={option.getChoiceFor(registration).label}
						price={option.getChoiceFor(registration).getPriceFor(registration)}
					/>
				))}
				{registration.totalPrice > 0 && (
					<div {...styles.basket('total')}>
						{t('shopbasket.totalprice') + ': '}
						<strong {...styles.basket('total-price')}>
							{formatPrice(registration.totalPrice)}
						</strong>
					</div>
				)}
			</div>
		</div>
	)
}

export const ShopBasketItem: React.FC<{
	title: string
	description: string
	indent?: boolean
	price?: number | false
}> = data => {
	const {title, description, price = false, indent = false} = data

	return (
		<div className={styles.basketitem.mod({indent})}>
			<div className={styles.basketitem('heading')}>
				<div className={styles.basketitem('heading-title')}>{title}</div>
				<div className={styles.basketitem('heading-description')}>
					{description}
				</div>
			</div>
			{price && price > 0 && (
				<div className={styles.basketitem('price')}>{formatPrice(price)}</div>
			)}
		</div>
	)
}
